import TicketCategoryGroupList from './TicketCategoryGroupList';

export default TicketCategoryGroupList;
